import type {
	ComboBoxFilterChangeEvent,
	MultiSelectChangeEvent,
} from "@tql/ui-components-react/kendo/dropdowns";

import type { IdName } from "~/shared/schemas/commodity-schema.ts";
import type { BoardColumn } from "~/shared/types/quote-board-types";

import { CustomerSearchFilter } from "../customer-search-filter.tsx";
import { LoadsHeader } from "../loads-header/loads-header.tsx";
import { SearchAllFilter } from "../search-all-filter/search-all-filter.tsx";
import { ShipmentDateFilter } from "../shipment-date-filter/shipment-date-filter.tsx";

type ExternalShipmentBoardHeaderProps = {
	searchAllValue: string;
	onSearchAllChange: (value: string) => void;
	externalCustomers: IdName[];
	selectedCustomers: IdName[];
	onCustomerChange: (e: MultiSelectChangeEvent) => void;
	onCustomerFilterChange: (e: ComboBoxFilterChangeEvent) => void;
	allColumns: BoardColumn[];
	onChangeColumn: (column: BoardColumn) => void;
	onClearFilters: () => void;
	onRefresh: () => void;
	onResetColumns?: () => void;
};

export const ExternalShipmentBoardHeader = ({
	searchAllValue,
	onSearchAllChange,
	externalCustomers,
	selectedCustomers,
	onCustomerChange,
	onCustomerFilterChange,
	allColumns,
	onChangeColumn,
	onClearFilters,
	onRefresh,
	onResetColumns,
}: ExternalShipmentBoardHeaderProps) => {
	return (
		<div className={"loads-header-row"}>
			<SearchAllFilter onChange={onSearchAllChange} value={searchAllValue} />
			<ShipmentDateFilter />
			{externalCustomers.length > 1 ? (
				<span className={"loads-header-filters"}>
					<CustomerSearchFilter
						data={externalCustomers}
						label={"Search Shipments by Customer"}
						onChange={onCustomerChange}
						onFilterChange={onCustomerFilterChange}
						placeholder={"select one or more customers"}
						selectAll={{ id: -1, name: "Select All" }}
						value={selectedCustomers}
					/>
				</span>
			) : null}
			<LoadsHeader
				columns={allColumns}
				onChangeColumn={onChangeColumn}
				onClearFilters={onClearFilters}
				onRefresh={onRefresh}
				onResetColumns={onResetColumns}
			/>
		</div>
	);
};
